import VehicleSnapshot from './vehicle-snapshot';

export default VehicleSnapshot;
